import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
export default function CommanFfcaDocumnets() {
    const AfflFacultyRemarksAvailaValidations = Yup.object({
        leaseDeed: Yup.string().required(ERROR_MSG).nullable(),
        structuralCertificate: Yup.string().required(ERROR_MSG).nullable(),
        sanitaryCertificate: Yup.string().required(ERROR_MSG).nullable(),
        fdr: Yup.string().required(ERROR_MSG).nullable(),
        buildingPlans: Yup.string().required(ERROR_MSG).nullable(),
        fireNoc: Yup.string().required(ERROR_MSG).nullable(),


    })
    const AfflFacRemarksFormik = useFormik({
        initialValues: {
            leaseDeed: "",
            structuralCertificate: "",
            sanitaryCertificate: "",
            fdr: "",
            buildingPlans: "",
            fireNoc: ""

        },
        validationSchema: AfflFacultyRemarksAvailaValidations,
        onSubmit: (values) => {

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveKeyDocuments`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetFFcaDocumentsData();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })



    const [ffcaDocuments, setffcaDocumnets] = useState([]);
    function GetFFcaDocumentsData() {
        let url = config.url.API_URL + `getKeyDocuments`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setffcaDocumnets(res?.data?.getKeyDocuments);
            }
            else {
                setffcaDocumnets([]);
            }
        })
    }

    useEffect(() => {
        GetFFcaDocumentsData();
    }, [])
    return (
        <>
            <FormikProvider value={AfflFacRemarksFormik}>
                <Form onChange={AfflFacRemarksFormik?.handleChange} onSubmit={AfflFacRemarksFormik?.handleSubmit}>
                    {ffcaDocuments.length === 0 ? (<>
                        <div className="table-responsive">

                            <table className="table table-condensed table-bordered  table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Document Name		</th>
                                        <th>Remarks of the FFCA team</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td style={{ textAlign: "left" }}>Lease/Own Land Deed</td>
                                        <td style={{ width: "45rem" }}>
                                            <Field as="select" className="form-control" name="leaseDeed" >
                                                <option value=''>---select---</option>
                                                <option value="Examined and found valid as per the Norms">Examined and found valid as per the Norms</option>
                                                <option value="Not Produced by College">Not Produced by College</option>
                                                <option value="Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building">
                                                    Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building
                                                </option>
                                            </Field>
                                            <ErrorMessage name="leaseDeed" component="div" className="text-error" />

                                        </td>
                                    </tr>

                                    <tr>
                                        <td>2</td>
                                        <td style={{ textAlign: "left" }}>Structural Stability Certificate</td>
                                        <td>
                                            <Field as="select" className="form-control" name="structuralCertificate">
                                                <option value=''>---select---</option>
                                                <option value="Examined and found valid as per the Norms">Examined and found valid as per the Norms</option>
                                                <option value="Not Produced by College">Not Produced by College</option>
                                                <option value="Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building">
                                                    Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building
                                                </option>
                                            </Field>
                                            <ErrorMessage name="structuralCertificate" component="div" className="text-error" />

                                        </td>
                                    </tr>

                                    <tr>
                                        <td>3</td>
                                        <td style={{ textAlign: "left" }}>Sanitary Certificate</td>
                                        <td>
                                            <Field as="select" className="form-control" name="sanitaryCertificate">
                                                <option value=''>---select---</option>
                                                <option value="Examined and found valid as per the Norms">Examined and found valid as per the Norms</option>
                                                <option value="Not Produced by College">Not Produced by College</option>
                                                <option value="Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building">
                                                    Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building
                                                </option>
                                            </Field>
                                            <ErrorMessage name="sanitaryCertificate" component="div" className="text-error" />

                                        </td>
                                    </tr>

                                    <tr>
                                        <td>4</td>
                                        <td style={{ textAlign: "left" }}>FDR</td>
                                        <td>
                                            <Field as="select" className="form-control" name="fdr">
                                                <option value=''>---select---</option>
                                                <option value="Examined and found valid as per the Norms">Examined and found valid as per the Norms</option>
                                                <option value="Not Produced by College">Not Produced by College</option>
                                                <option value="Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building">
                                                    Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building
                                                </option>
                                            </Field>
                                            <ErrorMessage name="fdr" component="div" className="text-error" />

                                        </td>
                                    </tr>

                                    <tr>
                                        <td>5</td>
                                        <td style={{ textAlign: "left" }}>Approved Building Plans</td>
                                        <td>
                                            <Field as="select" className="form-control" name="buildingPlans">
                                                <option value=''>---select---</option>
                                                <option value="Examined and found valid as per the Norms">Examined and found valid as per the Norms</option>
                                                <option value="Not Produced by College">Not Produced by College</option>
                                                <option value="Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building">
                                                    Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building
                                                </option>
                                            </Field>
                                            <ErrorMessage name="buildingPlans" component="div" className="text-error" />

                                        </td>
                                    </tr>

                                    <tr>
                                        <td>6</td>
                                        <td style={{ textAlign: "left" }}>Fire NOC</td>
                                        <td>
                                            <Field as="select" className="form-control" name="fireNoc">
                                                <option value=''>---select---</option>
                                                <option value="Examined and found valid as per the Norms">Examined and found valid as per the Norms</option>
                                                <option value="Not Produced by College">Not Produced by College</option>
                                                <option value="Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building">
                                                    Produced but it is not issued by Competent Authority (or) Expired (or) Not of this Building
                                                </option>
                                            </Field>
                                            <ErrorMessage name="fireNoc" component="div" className="text-error" />

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="button-cend pt-1 mb-5">
                            <button type="submit" className="badge text-bg-success rounded mt-2 float-end" style={{ padding: "10px 20px", fontSize: "15px" }}>
                                Submit
                            </button>
                        </div>

                    </>) : (<>
                        <div className="table-responsive">

                            <table className="table table-condensed table-bordered table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th > Document Name		</th>
                                        <th>Remarks of the FFCA team</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td className='text-left'>Lease/Own Land Deed</td>
                                        <td className='text-left'>{ffcaDocuments[0]?.lease_deed}</td>


                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td className='text-left'>Structural Stability Certificate</td>
                                        <td className='text-left'>{ffcaDocuments[0]?.structural_certificate}</td>



                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td className='text-left'>Sanitary Certificate</td>
                                        <td className='text-left'>{ffcaDocuments[0]?.sanitary_cerfificate}</td>



                                    </tr>
                                    <tr>

                                        <td>4</td>
                                        <td className='text-left'>FDR</td>
                                        <td className='text-left'> {ffcaDocuments[0]?.fdr}</td>



                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td className='text-left'>Approved Building Plans</td>
                                        <td className='text-left'>{ffcaDocuments[0]?.building_plans}</td>



                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td className='text-left'>Fire NOC</td>
                                        <td className='text-left'>{ffcaDocuments[0]?.fire_noc}</td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </>)}
                    <br />

                </Form>
            </FormikProvider>
        </>
    )
}
